import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllPOByPart = async (organisationID = "", partID = "") => {
    let assetFilters = {
      organisation: {
        id: {
          $eq: organisationID,
        },
      },
      orderItems: {
        items: {
          part: {
            id: {
              $in: partID,
            },
          },
        },
      },
    };
  
    const queryParams = {
      sort: ["countNumId:desc"],
      filters: assetFilters,
      populate: [
        "customFields",
        "vendors.logo",
        "assets.image",
        "procedure",
        "createdByUser",
        "category",
        "createdByUser.profileImage",
        "inventory",
        "inventory.location",
        "inventory.area",
        "details",
        "details.vendor",
        "orderItems",
        "orderItems.items",
        "orderItems.items.part",
        "billingAddress",
        "updatedByUser",
        "approvedByUser",
        "updatedByUser.profileImage",
      ],
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `purchase-orders?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
     
      return response.data.data;
    } catch (err) {
      
      if (err.response) {
        
      } else if (err.request) {
        
      } else {
        
      }
     
    }
  };
  